module.exports = __webpack_public_path__ + "img/Support-skill-517.0eb26b92.png";